import { Button, Dialog, DialogContent, DialogFooter, DialogTrigger, Text } from '@chatsdet/ui';
import { Warning } from '@phosphor-icons/react';

type TemplateDeleteDialogProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  templateName: string;
  activeInstanceCount: number;
  isDeleting: boolean;
  onDelete: () => void;
};

export function TemplateDeleteDialog({
  isOpen,
  onOpenChange,
  templateName,
  activeInstanceCount,
  isDeleting,
  onDelete,
}: TemplateDeleteDialogProps) {
  return (
    <DialogTrigger isOpen={isOpen} onOpenChange={onOpenChange} size="sm">
      <span />
      <Dialog
        title="Delete Template"
        description="Are you sure you want to delete this template? This action cannot be undone."
      >
        <DialogContent>
          {activeInstanceCount > 0 && (
            <div className="flex items-center gap-2 rounded-md bg-destructive/10 px-3 py-2 mb-3">
              <Warning size={16} className="text-destructive shrink-0" />
              <Text size="sm" className="text-destructive">
                {activeInstanceCount} active instance{activeInstanceCount > 1 ? 's' : ''} will be
                terminated.
              </Text>
            </div>
          )}
          <Text>
            This will permanently delete the template "{templateName}"
            {activeInstanceCount > 0 ? ' and terminate all running instances' : ''}. This action
            cannot be undone.
          </Text>
        </DialogContent>
        <DialogFooter>
          <Button variant="outline" onPress={() => onOpenChange(false)} isDisabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onPress={onDelete} isDisabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete Template'}
          </Button>
        </DialogFooter>
      </Dialog>
    </DialogTrigger>
  );
}
